import { render } from "./VuexLicenceFormItem.vue?vue&type=template&id=67ae6d88"
import script from "./VuexLicenceFormItem.vue?vue&type=script&lang=js"
export * from "./VuexLicenceFormItem.vue?vue&type=script&lang=js"
script.render = render

export default script